import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getSiteSurveyFilterConfig = ({ filters }: { filters: any }) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		filters[FILTER_CONFIG_NAMES.WALKTHROUGH_COMPLETED_AT_KEY],
		filters[FILTER_CONFIG_NAMES.CREATED_AT],
	].filter(Boolean);
};
